module.exports = __webpack_public_path__ + "static/media/kenny_wan.f6ce92d3.png";